<template>
  <b-row>
    <b-col cols="12">
      <b-row class="pt-1">
        <b-col cols="12">
          <div class="flex h-full" style="cursor: pointer;">
            <div :class="[(currentRoute === 'subscribers') ? 'menu-item-active' : 'menu-item']" @click="select('subscribers')">
              <div class="flex mt-6">
                <div style="font-size: 14px" v-if="company.subType !== 'private-company-limited-by-guarantee-without-shares'">Subscribers</div>
                <div style="font-size: 14px" v-else>Members</div>
                <b-badge class="bg-blue mb-1 mx-1 ">
                  {{subscribersTotal}}
                </b-badge>
              </div>
            </div>
            <div :class="[(currentRoute === 'directors') ? 'menu-item-active' : 'menu-item']" @click="select('directors')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Directors</div>
                <b-badge class="bg-blue mx-1 mb-1">
                  {{(directorsTotal)}}
                </b-badge>
              </div>
            </div>
            <div :class="[(currentRoute === 'secretary') ? 'menu-item-active' : 'menu-item']" @click="select('secretary')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Secretary</div>
                <b-badge class="bg-blue mx-1 mb-1">
                  {{(secretaryTotal)}}
                </b-badge>
              </div>
            </div>
            <div :class="[(currentRoute === 'deputy-secretary') ? 'menu-item-active' : 'menu-item']" @click="select('deputy-secretary')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Deputy Secretary</div>
                <b-badge class="bg-blue mx-1 mb-1">
                  {{(deputySecretaryTotal)}}
                </b-badge>
              </div>
            </div>
            <div v-if="company.subType !== 'private-company-limited-by-guarantee-without-shares'" :class="[(currentRoute === 'shares') ? 'menu-item-active' : 'menu-item']" @click="select('shares')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Share Information</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'address') ? 'menu-item-active' : 'menu-item']" @click="select('address')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Address</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'documents') ? 'menu-item-active' : 'menu-item']" @click="select('documents')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Documents</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'annual-returns') ? 'menu-item-active' : 'menu-item']" @click="select('annual-returns')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Annual Returns</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'filing-history') ? 'menu-item-active' : 'menu-item']" @click="select('filing-history')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Filing History</div>
              </div>
            </div>

              <div :class="[(currentRoute === 'correction-history') ? 'menu-item-active' : 'menu-item']" @click="select('correct-history')">
                  <div class="flex mt-6">
                      <div style="font-size: 14px">Corrections</div>
                  </div>
              </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-row>
            <CompanySubscribers v-if="currentRoute === 'subscribers'"/>
            <CompanyDirectors v-if="currentRoute === 'directors'"/>
            <CompanySecretary v-if="currentRoute === 'secretary'"/>
            <CompanyDeputySecretary v-if="currentRoute === 'deputy-secretary'"/>
            <CompanyShares :brn="company.brn" v-if="currentRoute === 'shares' && company.subType !== 'private-company-limited-by-guarantee-without-shares'"/>
            <CompanyAddress :is-filed="getFilingCompliance.data.formCompliance.ADDRESS" :brn="company.brn" v-if="currentRoute === 'address'"/>
            <CompanyDocuments :brn="company.brn" :documents="company.documents" v-if="currentRoute === 'documents'"/>
            <AnnualReturnsStatus :brn="company.brn" v-if="currentRoute === 'annual-returns'"/>
            <FilingHistory :brn="company.brn" v-if="currentRoute === 'filing-history'"/>
             <CorrectionHistory :brn="company.brn" v-if="currentRoute === 'correction-history'" >Corrections History</CorrectionHistory>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import CompanySubscribers from "@/views/home/services/registry/business/files/tabs/company_data/CompanySubscribers";
import CompanyDirectors from "@/views/home/services/registry/business/files/tabs/company_data/CompanyDirectors";
import CompanyShares from "@/views/home/services/registry/business/files/tabs/company_data/CompanyShares";
import CompanyAddress from "@/views/home/services/registry/business/files/tabs/company_data/CompanyAddress";
import CompanyDocuments from "@/views/home/services/registry/business/files/tabs/company_data/CompanyDocuments";
import FilingHistory from "@/views/home/services/registry/business/files/tabs/company_data/FilingHistory";
import {mapActions, mapGetters} from "vuex";
import CompanySecretary from "@/views/home/services/registry/business/files/tabs/company_data/CompanySecretary";
import CompanyDeputySecretary from "@/views/home/services/registry/business/files/tabs/company_data/CompanyDeputySecretary";
import AnnualReturnsStatus
    from "@/views/home/services/registry/business/files/tabs/company_data/AnnualReturnsStatus.vue";
import CorrectionHistory from "@/views/home/services/registry/business/files/tabs/company_data/CorrectionHistory.vue";

export default {
  name: "CompanyFile",
  components: {
      CorrectionHistory,
    AnnualReturnsStatus,
    CompanySecretary, CompanyDeputySecretary, FilingHistory, CompanyDocuments, CompanyAddress, CompanyShares, CompanyDirectors, CompanySubscribers
  },
  props:{
    company:Object
  },
  data(){
    return{
      currentRoute:"subscribers",
      subscribersTotal:0,
      directorsTotal:0,
      secretaryTotal:0,
      deputySecretaryTotal:0
    }
  },
  mounted() {
      if (this.company.status === 'WALID') {
          this.errorToast("Error ", "No results found")
      } else {
          this.fetchCompanyCurrentMembers(this.company.brn)
          this.fetchCompanyDirectors(this.company.brn)
          this.fetchCompanySecretary(this.company.brn)
          this.fetchCompanyDeputySecretary(this.company.brn)
          this.fetchFilingCompliance(this.company.brn)
          if(this.company.subEntityType === 'single-member-company'){
              this.fetchSmcForm1Details(this.company.brn)
          }
      }
  },
  methods:{
    ...mapActions(["fetchCompanyDirectors", "fetchCompanySecretary", "fetchCompanyDeputySecretary", "fetchCompanyCurrentMembers", "fetchFilingCompliance","fetchSmcForm1Details"]),
    select(route){
      this.currentRoute = route
    },

  },
  computed:{
    ...mapGetters(["getCompanySubscribers", "getCompanyDirectors", "getCompanySecretary", "getCompanyDeputySecretary", "getFilingCompliance","getForm1Details"])
  },
  watch:{
    getCompanySubscribers(data){
      this.subscribersTotal = data.data.content.length
    },
    getCompanyDirectors(data){
      this.directorsTotal = data.data.content.length
    },
    getCompanySecretary(data){
      if(data){
        this.secretaryTotal = 1
      }
    },
    getCompanyDeputySecretary(data){
      if(data && data.data){
        this.deputySecretaryTotal = 1
      } else {
        this.deputySecretaryTotal = 0
      }
    }
  }
}
</script>

<style scoped>

</style>